<template>
    <rkm-form ref="Form">
        <box-unidade-local :data="{ form, model }" />

        <box-cota
            :data="{ form, model }"
            class="mt-4"
        />

        <box-mensagem-protocolo
            :data="{ model }"
            class="mt-4"
        />

        <box-ocupacao
            :data="{ form, model }"
            class="mt-4"
        />

        <box-supervisor
            :data="{ form, model }"
            class="mt-4"
        />

        <box-controle-jornada
            :data="{ form, model }"
            class="mt-4"
        />

        <box-exame-ambulatorio-atendimento
            :data="{ form, model }"
            class="mt-4"
        />

    </rkm-form>
</template>

<script>

// Components.
import BoxUnidadeLocal from './components/unidade-local/Index'
import BoxCota from './components/cota/Index'
import BoxMensagemProtocolo from './components/mensagem-protocolo/Index'
import BoxOcupacao from './components/ocupacao/Index'
import BoxSupervisor from './components/supervisor/Index'
import BoxControleJornada from './components/controle-jornada/Index'
import BoxExameAmbulatorioAtendimento from './components/exame-ambulatorio-atendimento/Index'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    components: {
        BoxUnidadeLocal,
        BoxCota,
        BoxMensagemProtocolo,
        BoxOcupacao,
        BoxSupervisor,
        BoxControleJornada,
        BoxExameAmbulatorioAtendimento

    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameImagem.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        form: {},
        model: {}
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const unidades = this.model.unidades.map(unidadeLocal => ({
                unidadeId: unidadeLocal.unidadeId,
                executante: unidadeLocal.executante,
                prestador: unidadeLocal.prestador,
                enviaSms: unidadeLocal.enviaSms,
                infraestruturaId: unidadeLocal.infraestruturaId,
                sms: {
                    diaAntecedencia: unidadeLocal.sms.diaAntecedencia,
                    envioDe: unidadeLocal.sms.periodoEnvio.start,
                    envioAte: unidadeLocal.sms.periodoEnvio.end,
                    exames: unidadeLocal.sms.exames.map(exame => exame.id),
                },
            }))

            const cotaSolicitante = this.model.cotas.map(cotaPrestador => ({
                unidadeId: cotaPrestador.unidadeId,
                infraestruturaId: cotaPrestador.infraestruturaId,
                cotaSolicitante: cotaPrestador.cotaSolicitante,
            }))

            const mensagemProtocolo = this.model.mensagemProtocolo

            const ocupacoes = this.model.ocupacoes.map(ocupacao => ({
                ocupacaoId: ocupacao.ocupacaoId
            }))

            const supervisores = this.model.supervisores.map(supervisor => ({
                usuarioId: supervisor.usuarioId
            }))

            const controleJornada = this.model.controleJornada
            const exibirExameAmbulatorioAtendimento = this.model.exibirExameAmbulatorioAtendimento

            return this.camelObjectKeysToSnakeRecursive({
                unidades, cotaSolicitante, mensagemProtocolo, ocupacoes, supervisores, controleJornada, exibirExameAmbulatorioAtendimento
            })
        },
    },
    mixins: [repository, stringCase, object, error],
}
</script>